import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import { useSelector } from 'react-redux';
import { format, addDays } from 'date-fns';
import Chip from '@mui/material/Chip';
import BrazilMoney from 'utils/BrazilMoney';

import { purple, red, teal } from '@mui/material/colors';
// import transitions from "@mui/styles/transitions";

function Transactions() {
  const [transaction, setTransaction] = useState([]);
  const [exportData, setExportData] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const nameProperty = useSelector((state) => state.nameProperty.nameProperty);

  const columns = [
    {
      title: 'Data',
      field: 'date',
      hideFilterIcon: true,
      render: (rowData) => format(addDays(new Date(rowData.date), 1), 'dd/MM/yyyy'),
    },
    {
      title: 'Descrição',
      field: 'description',
      hideFilterIcon: true,
    },
    {
      title: 'Procedência',
      field: 'source',
      hideFilterIcon: true,
    },
    {
      title: 'Conta de Origem',
      field: 'origin',
      hideFilterIcon: true,
      render: (rowData) => (!(rowData.origin === null) ? rowData.origin.name : '-'),
    },
    {
      title: 'Conta de Destino',
      field: 'destiny',
      hideFilterIcon: true,
      render: (rowData) => (!(rowData.destiny === null) ? rowData.destiny.name : '-'),
    },
    {
      title: 'Tipo',
      field: 'type',
      hideFilterIcon: true,
      render: (rowData) => (
        <Chip
          style={{
            backgroundColor:
              rowData.type === 'pagamento' || rowData.type === 'Saque'
                ? 'red'
                : '#0BA25A',

            color: '#fff',
          }}
          label={rowData.type[0].toUpperCase() + rowData.type.substr(1)}
        />
      ),
    },
    {
      title: 'Saldo',
      field: 'value',
      editable: 'never',
      hideFilterIcon: true,
      render: (rowData) => <BrazilMoney value={rowData.quantity} />,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get('/transaction');
        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          const data = await response.data;
          const organizedData = await data.map((_transaction) => ({
            date: _transaction.date,
            description: _transaction.description,
            origin: !_transaction.origin?.name
              ? 'Não definido'
              : _transaction.origin?.name,
            destiny: !_transaction.destiny?.name
              ? 'Não definido'
              : _transaction.destiny?.name,
            type: _transaction.type,
            value: _transaction.quantity,
          }));

          setExportData(organizedData);
          setTransaction(data);
        }
      } catch (err) {

      }
    }
    loadData();
  }, [nameProperty]);

  function setData(newData) {
    const tempData = [];
    transaction.map((transaction) => (transaction.id === newData.id
      ? tempData.push(newData)
      : tempData.push(transaction)));
    setTransaction(tempData);
  }

  return (
    <Table
      copy={false}
      title="Movimentações"
      route="/transactions/"
      routeAdd="/transaction/"
      columns={columns}
      data={transaction}
      setData={setData}
      dataLoaded={openProgress}
      exportData={exportData}
    />
  );
}

export default Transactions;
